import React from 'react';
import get from 'lodash/get';
import { bool } from 'prop-types';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { commonAutomationIds, hero3BannerAutomationIds } from '../CoreMediaPage/CMPage.config';

const HeroLegalText = (props) => {
    const primaryLegalText = get(props, 'legalText', '');
    const isPrimary = get(props, 'isPrimary', true);
    const styles = get(props, 'styles', {});

    const { value, openInNewTab } = primaryLegalText?.urlHolder;
    const linkTragetValue = openInNewTab ? '_blank' : '';
    return (
        <div
            className={dt([
                'text-xsmall',
                'md:mb-4',
                props.isCTAEmpty ? 'smOnly:mb-1' : 'smOnly:mb-4',
                'smOnly:text-center',
            ])}
            data-automation-id={
                isPrimary ? commonAutomationIds?.LEGALTEXT : hero3BannerAutomationIds?.LEGALTEXT
            }
        >
            <span style={{ color: `#${styles?.legalTextColor}` }} id="HeroLegalText">
                {primaryLegalText?.legalText}
                &nbsp;{' '}
                <a
                    className={dt(['underline', 'text-gray-70', 'hover:text-gray-70'])}
                    aria-label={primaryLegalText?.legalLinkText}
                    target={linkTragetValue}
                    href={value}
                    alt={primaryLegalText?.legalAltText}
                    title={primaryLegalText?.legalAltText}
                    data-automation-id={
                        isPrimary
                            ? commonAutomationIds?.LEGALLINK
                            : hero3BannerAutomationIds?.LEGALLINK
                    }
                    rel="noreferrer noopener"
                    style={{ color: `#${styles?.legalLinkColor}` }}
                >
                    {primaryLegalText?.legalLinkText}
                </a>
            </span>
        </div>
    );
};

HeroLegalText.defaultProps = {
    isCTAEmpty: false,
};

HeroLegalText.propTypes = {
    isCTAEmpty: bool,
};

export default HeroLegalText;
